import type { MarketGroupsApi } from "@/v2/api/metadata/market-groups";
import type { BackofficeContext } from "@/v2/framework/context/types";
import type { TranslationsTab } from "@/v2/framework/dialog/types";
import { readApiData } from "@/v2/api/response";
import { formatTranslationsForUpdate } from "@/services/helpers";
import { buildMarketGroupTranslationFields } from "../../translation-fields";

export function createTranslationsTab(options: {
  ctx: BackofficeContext;
  marketGroupsApi: MarketGroupsApi;
}): TranslationsTab {
  const { ctx, marketGroupsApi } = options;

  return {
    kind: "translations",
    id: "translations",
    label: "Translations",
    persistence: "isolated",
    parentSubmitWithUnsavedTranslations: "block",
    fields: buildMarketGroupTranslationFields,
    api: {
      get: async ({ values }) => {
        const marketGroup = values as { id: string | number };
        const translations = readApiData(await marketGroupsApi.getTranslations(marketGroup.id));
        const list = Array.isArray(translations) ? translations : [];
        const translationsPerLanguage = (list as Array<{ languageId: string | number }>).reduce(
          (acc, translation) => {
            acc.set(String(translation.languageId), translation);
            return acc;
          },
          new Map(),
        );
        return { languages: ctx.read.languages(), translationsPerLanguage };
      },
      save: async (model, saveCtx) => {
        const entityId = (saveCtx.values as { id: string | number }).id;
        await marketGroupsApi.update(entityId, {
          translations: formatTranslationsForUpdate(
            model as Parameters<typeof formatTranslationsForUpdate>[0],
          ),
        });
      },
    },
  };
}
